import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { products } from '../../data/products';
export function IngredientMarquee() {
  const reduce = useReducedMotion();
  const names = products.filter(p => p.category !== 'sets').map(p => p.name);
  const row = [...names, ...names];
  return <div className="overflow-hidden bg-clay py-5 text-canvas" aria-hidden="true" data-id="element-71" data-mp="1b08w8zkcvpt7">
      <motion.ul className="flex w-max items-center gap-8 whitespace-nowrap" animate={reduce ? undefined : {
      x: ['0%', '-50%']
    }} transition={{
      duration: 45,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-72" data-mp="1fzlk9nmyr2xd">
        {row.map((n, i) => <li key={i} className="flex items-center gap-8 text-2xl font-semibold tracking-display sm:text-3xl" data-id="element-73" data-mp="1otgq6xvwsxe2" data-mpi={i}>
            {n}
            <span className="h-2 w-2 rotate-45 bg-blush" data-id="element-74" data-mp="1ypjo1rjqa9v7" />
          </li>)}
      </motion.ul>
    </div>;
}